import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import Dashboard from './components/Dashboard/Dashboard';
import MessageTemplates from './components/MessageTemplates/MessageTemplates';
import Automations from './components/Automations/Basic';
import 'bootstrap/dist/css/bootstrap.min.css';
import MessageTemplateForm from './components/MessageTemplates/MessageTemplateForm';
import ContactTable from './components/Contacts/Contacts';
import AddContact from './components/Contacts/AddContactForm';
import ImportExportContacts from './components/Contacts/ImportExportContacts';
import ContactListsAndTags from './components/Contacts/ContactListsAndTags';
import NotificationTable from './components/Notifications/Notifications';
import AddNotification from './components/Notifications/AddNotification';
import Messaging from './components/Analytics/Messaging';
import NotificationAnalytics from './components/Analytics/NotificationAnalytics';
import MessageTemplatesAnalytics from './components/Analytics/MessageTemplatesAnalytics';
import Basic from './components/Automations/Basic';
import AutoReplies from './components/Automations/AutoReplies';
import ChatApp from './components/Inbox/Inbox';
import AccountDetails from './components/Profile/AccountDetails';
import Login from './components/Login/Login';
import MessageTempView from './components/MessageTemplates/MessageTempView';
import EmRegistation from './components/Login/EmRegistation';
import AdminApprovalPage from './components/Login/ApproveReject';
import LoginPass from './components/Login/loginPass';
import MessagePanel from './components/Dashboard/MessagePanel';
import SendMessaging from './components/Dashboard/SendMessaging';
import ReportBug from './components/Profile/ReportBug';
import ForgotPassword from './components/Login/ForgotPassword';
import ResetPassword from './components/Login/ResetPassword';
import TableCreate from './components/Contacts/TableCreate';
import UserTablesList from './components/Contacts/UserTablesList';
import Appointment from './components/MessageTemplates/Appointment';
import TemplateForm from './components/TemplateConfig/TemplateForm';
import TemplateList from './components/TemplateConfig/TemplateList';
import AdminTable from './components/Admin/AdminTable';

import USVisaAppointment from './components/MessageTemplates/USVisaAppointment';
import ColumnMapping from './components/Admin/ColumnMapping';
import Language from './components/Admin/Language';
import CreateUser from './components/Users/CreatUser';
import CreateGroup from './components/GroupsAPI/CreateGroup';
import GroupInfo from './components/GroupsAPI/GroupInfo';
import GroupInvite from './components/GroupsAPI/GroupInvite';
import SendGroupMessage from './components/GroupsAPI/SendGroupMessage';
import MessageAnalytics from './components/MessageAnalytics/MessageAnalytics';
import ReceivedMessages from './components/MessageAnalytics/ReceivedMessage';
import SendMessage from './components/MessageAnalytics/SendMessage';
import AddGrop from './components/Contacts/AddGrop';
import UserManagement from './components/Users/UserManagement';

// import Normal from './components/PPAppointment/Normal';
// import NormalRenewal from './components/PPAppointment/NormalRenewal';
// import Tatkal from './components/PPAppointment/Tatkal';
// import TatkalRenewal from './components/PPAppointment/TatkalRenewal';
// import Minor from './components/PPAppointment/Minor';
// import MinorRenawal from './components/PPAppointment/MinorRenawal';


const App = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/';
    const isRegistrationPage = location.pathname === '/em-registation';
    const isApprovePage = location.pathname === '/adminapprove';
    const isLoginPass = location.pathname === '/loginpass-login';
    const isForgotPassword = location.pathname === '/forgot-password';
    const isResetpassword = location.pathname.startsWith('/resetpassword/');


    return (
        <div className="d-flex flex-column flex-md-row vh-100">
            {!isLoginPage && !isRegistrationPage && !isApprovePage && !isLoginPass && !isForgotPassword && !isResetpassword && <Sidebar />}
            <div className="flex-grow-1 d-flex flex-column">
                {!isLoginPage && !isRegistrationPage && !isApprovePage && !isLoginPass && !isForgotPassword && !isResetpassword && <Header />}
                <div className="p-3 overflow-auto" style={{ backgroundColor: '#f8f9fa' }}>
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/MessagePanel/Message-Panel" element={<MessagePanel />} />
                        <Route path="/" element={<Login />} />
                        <Route path="/loginpass-login" element={<LoginPass />} />
                        <Route path="/adminapprove" element={<AdminApprovalPage />} />
                        <Route path="/em-registation" element={<EmRegistation />} />
                        <Route path="/send-messaging" element={<SendMessaging />} />
                        <Route path="/message-templates" element={<MessageTemplates />} />
                        <Route path="/message-temp-view" element={<MessageTempView />} />
                        <Route path="/singlecontacts" element={<ContactTable />} />
                        <Route path="/notifications" element={<NotificationTable />} />
                        <Route path="/messaging" element={<Messaging />} />
                        <Route path="/automations" element={<Automations />} />
                        <Route path="/inbox" element={<ChatApp />} />
                        <Route path='/add-templates' element={<MessageTemplateForm />} />
                        <Route path='/add-new' element={<AddContact />} />

                        <Route path='/add-group' element={<AddGrop />} />

                        <Route path='/UserManagement' element={<UserManagement />} />

                        <Route path='/table-create' element={<TableCreate />} />
                        <Route path='/usertables-list' element={<UserTablesList />} />

                        <Route path='/admin-table' element={<AdminTable />} />

                        <Route path='/column-mapping' element={<ColumnMapping />} />
                        <Route path='/language' element={<Language />} />

                        <Route path='/appointment' element={<Appointment />} />
                        <Route path='/message-templates/us-visa-appointment' element={<USVisaAppointment />} />

                        <Route path='/import-export' element={<ImportExportContacts />} />
                        <Route path='/list-tags' element={<ContactListsAndTags />} />
                        <Route path='/add-notification' element={<AddNotification />} />
                        <Route path='/notificationss' element={<NotificationAnalytics />} />
                        <Route path='/message-templates-analytics' element={<MessageTemplatesAnalytics />} />
                        <Route path='/basic' element={<Basic />} />
                        <Route path='/auto-replies' element={<AutoReplies />} />
                        <Route path='/profile' element={<AccountDetails />} />

                        <Route path='/reportbug' element={<ReportBug />} />

                        <Route path='/forgot-password' element={<ForgotPassword />} />
                        <Route path="/resetpassword/:resetToken" element={<ResetPassword />} />


                        <Route path="/template-Form" element={<TemplateForm />} />
                        <Route path="/template-list" element={<TemplateList />} />


                        {/***************varma */}
                        <Route path="/message_analytics" element={<MessageAnalytics />} />
                        <Route path="/message_analytics/ReceivedMessages" element={<ReceivedMessages />} />
                        <Route path="/message_analytics/SendMessage" element={<SendMessage />} />
                        <Route path='/userCreate' element={<CreateUser />} />
                        <Route path='/createGroup' element={<CreateGroup />} />
                        <Route path='/getGroups' element={<GroupInfo />} />
                        <Route path='/groupsInvite' element={<GroupInvite />} />
                        <Route path='/groupMessage' element={<SendGroupMessage />} />

                        {/* <Route path='/normal' element={<Normal />} />
                        <Route path='/normal-renewal' element={<NormalRenewal />} />
                        <Route path='/tatkal' element={<Tatkal />} />
                        <Route path='/tatkal-renewal' element={<TatkalRenewal />} />
                        <Route path='/minor' element={<Minor />} />
                        <Route path='/minor-renewal' element={<MinorRenawal />} /> */}
                    </Routes>
                </div>
            </div>
        </div>
    );
};

const Root = () => (
    <Router>
        <App />
    </Router>
);

export default Root;
